import { render, staticRenderFns } from "./AssociateServiceRequest.vue?vue&type=template&id=10475802&"
import script from "./AssociateServiceRequest.vue?vue&type=script&lang=js&"
export * from "./AssociateServiceRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports